module.exports = __webpack_public_path__ + "static/professional-development-icon-94bad9107a3be25501e6cf464df2b59c.svg";